"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.infoBoxBodyTF = exports.infoboxFooterThematic = exports.infoboxFooter = exports.countyInfoBoxBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _InfoboxField = _interopRequireDefault(require("../components/InfoboxField"));

var _ZoomToPointButton = _interopRequireDefault(require("../components/ZoomToPointButton"));

var _DateFormatter = _interopRequireDefault(require("../modules/DateFormatter"));

var _NumberFormatter = _interopRequireDefault(require("../modules/NumberFormatter"));

var _LookUpTextField = _interopRequireDefault(require("../components/LookUpTextField"));

var _layerConfig = require("./layerConfig");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var iconMap = {
  customersAffected: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'exclamation-triangle']
  }),
  numOutages: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'lightbulb-slash']
  }),
  timeOff: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'clock']
  }),
  feederName: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'minus']
  }),
  crewStatus: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'user-hard-hat']
  }),
  cause: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'file-alt']
  }),
  etr: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'stopwatch']
  }),
  outageId: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'tag']
  }),
  default: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'exclamation-triangle']
  })
};

var infoBoxBody = function infoBoxBody(outage, bounds) {
  var desc = outage.desc,
      clickedLatLng = outage.clickedLatLng;
  var customersAffected = desc.cust_a,
      start = desc.start,
      feederId = desc.feeder_id,
      crewStatus = desc.crew_status,
      cause = desc.cause,
      etr = desc.etr,
      id = desc.inc_id,
      cluster = desc.cluster,
      numOutages = desc.n_out;
  var customersAffectedLink;

  if (bounds) {
    customersAffectedLink = bounds.contains(clickedLatLng) ? /*#__PURE__*/_react.default.createElement("a", {
      target: '_blank',
      href: "/eoutages/eoutages-map/customersaffected.html#/outage/".concat(id),
      rel: 'noreferrer'
    }, "View Customers Affected") : undefined;
  } else {
    customersAffectedLink = /*#__PURE__*/_react.default.createElement("a", {
      target: '_blank',
      href: "/eoutages/eoutages-map/customersaffected.html#/outage/".concat(id),
      rel: 'noreferrer'
    }, "View Customers Affected");
  }

  if (cluster) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'infobox-body-outage'
    }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
      highlight: true,
      name: 'Number of Outages',
      icon: iconMap.numOutages
    }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, numOutages)), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
      highlight: true,
      name: (0, _layerConfig.getTypeLabel)('REGULAR'),
      icon: iconMap.customersAffected
    }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, customersAffected)));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: 'infobox-body-outage'
  }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    highlight: true,
    name: (0, _layerConfig.getTypeLabel)('REGULAR'),
    icon: iconMap.customersAffected
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, customersAffected)), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Time Off',
    icon: iconMap.timeOff
  }, /*#__PURE__*/_react.default.createElement(_DateFormatter.default, null, start)), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Feeder Name',
    value: feederId,
    icon: iconMap.feederName
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Crew Status',
    value: crewStatus,
    icon: iconMap.crewStatus
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Probable Cause',
    value: cause,
    icon: iconMap.cause
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Estimated Restoration',
    icon: iconMap.etr
  }, (0, _momentTimezone.default)(etr).isValid() ? /*#__PURE__*/_react.default.createElement(_DateFormatter.default, null, etr) : /*#__PURE__*/_react.default.createElement(_LookUpTextField.default, null, etr)), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Outage ID',
    value: id,
    icon: iconMap.outageId
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: ''
  }, customersAffectedLink)));
};

var countyInfoBoxBody = function countyInfoBoxBody(outage) {
  var desc = outage.desc;
  var customersAffected = desc.cust_a;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: 'infobox-body-outage'
  }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    highlight: true,
    name: (0, _layerConfig.getTypeLabel)('REGULAR'),
    icon: iconMap.customersAffected
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, customersAffected))));
};

exports.countyInfoBoxBody = countyInfoBoxBody;

var infoboxFooter = function infoboxFooter(outage) {
  var desc = outage.desc,
      clickedLatLng = outage.clickedLatLng;
  var cluster = desc.cluster;

  if (cluster) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'infobox-footer'
    }, /*#__PURE__*/_react.default.createElement(_ZoomToPointButton.default, clickedLatLng));
  }

  return /*#__PURE__*/_react.default.createElement("div", null, "\xA0");
};

exports.infoboxFooter = infoboxFooter;

var infoboxFooterThematic = function infoboxFooterThematic(outage) {
  var clickedLatLng = outage.clickedLatLng;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'infobox-footer'
  }, /*#__PURE__*/_react.default.createElement(_ZoomToPointButton.default, clickedLatLng));
};

exports.infoboxFooterThematic = infoboxFooterThematic;

var infoBoxBodyTF = function infoBoxBodyTF(outage, bounds) {
  var desc = outage.desc,
      clickedLatLng = outage.clickedLatLng;
  var customersServed = desc.cust_s,
      transformerId = desc.tf_id,
      cluster = desc.cluster,
      numOutages = desc.n_out,
      incidentId = desc.inc_id,
      type = desc.type;
  var customersAffectedLink;

  if (bounds) {
    customersAffectedLink = bounds.contains(clickedLatLng) ? /*#__PURE__*/_react.default.createElement("a", {
      target: '_blank',
      href: "/eoutages/eoutages-map/customersaffected.html#/outage/".concat(incidentId),
      rel: 'noreferrer'
    }, "View Customers Affected") : undefined;
  } else {
    customersAffectedLink = /*#__PURE__*/_react.default.createElement("a", {
      target: '_blank',
      href: "/eoutages/eoutages-map/customersaffected.html#/outage/".concat(incidentId),
      rel: 'noreferrer'
    }, "View Customers Affected");
  }

  if (cluster) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'infobox-body-outage'
    }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
      highlight: true,
      name: 'Number of Outages',
      icon: iconMap.numOutages
    }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, numOutages)));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: 'infobox-body-outage'
  }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Transformer ID',
    value: transformerId,
    icon: iconMap.default
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    highlight: true,
    name: "Number of ".concat((0, _layerConfig.getTypeLabel)(type)),
    icon: iconMap.customersAffected
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, customersServed)), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: 'Outage ID',
    value: incidentId,
    icon: iconMap.outageId
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: ''
  }, customersAffectedLink)));
};

exports.infoBoxBodyTF = infoBoxBodyTF;
var _default = infoBoxBody;
exports.default = _default;